import type { ReactNode } from 'react';

import Text from '~/common/components/Texts/Text';
import Divider from '~/common/mui/Divider';
import Box from '~/common/mui/Layout/Box';

type AddressCardProps = {
  children: ReactNode;
};

export function AddressCard(props: Readonly<AddressCardProps>) {
  return (
    <Box
      sx={{
        height: '24rem',
        padding: '1.5rem',
        borderRadius: '8px',
        border: '1px solid',
        borderColor: 'gray.200',
        width: '100%',
        display: 'flex',
        position: 'relative',
      }}
    >
      {props.children}
    </Box>
  );
}

type AddressCardTitleProps = {
  children: ReactNode;
};

export function AddressCardTitle(props: Readonly<AddressCardTitleProps>) {
  return (
    <Text
      sx={{
        textTransform: 'uppercase',
        color: 'gray.600',
        fontWeight: 500,
        fontSize: '0.75rem',
      }}
    >
      {props.children}
    </Text>
  );
}

type AddressCardContentProps = {
  children: ReactNode;
  width?: string;
};

export function AddressCardContent(props: Readonly<AddressCardContentProps>) {
  return <Box sx={{ width: props.width ?? '100%' }}>{props.children}</Box>;
}

export function AddressCardSeparator() {
  return (
    <Divider
      orientation="vertical"
      flexItem
      sx={{ marginX: '1.5rem' }}
      variant="middle"
    />
  );
}

type AddressCardActionsProps = {
  children: ReactNode;
};

export function AddressCardActions(props: Readonly<AddressCardActionsProps>) {
  return (
    <Box
      sx={{
        margin: '0 0.5rem 0 0',
        position: 'absolute',
        bottom: '0',
        right: '0',
        display: 'flex',
        gap: '0.5rem',
      }}
    >
      {props.children}
    </Box>
  );
}
